import React from "react";
import Dashboard from "../../components/admin/Dashboard";

const AdminDashboard: React.FC = () => {
  return (
    <Dashboard/>
  );
};

export default AdminDashboard;